import type { IProduct, RightBundle, SubscriptionKeyType } from '@wegic/price-ui';
import { EBillInterval, PLAN_TYPE_STRATEGY, PRICING_MODAL_ORIGIN_KEY, PRICING_MODAL_POPOUP_TYPE_KEY, PricingModalOrigin, SetPlanType } from '@wegic/price-ui';
import { nanoid } from 'nanoid';
import { PRICING_MODAL_CLICK_ID_KEY, SELECT_PRODUCT } from '@/modules/Subscribe/const';

export function setPlanKey(type: RightBundle, viewMode: EBillInterval, billIntervalCount: number) {
  const typeStr = PLAN_TYPE_STRATEGY[type] ?? SetPlanType.BASIC;
  const viewModeStr = viewMode === EBillInterval.Month ? SetPlanType.MONTH : SetPlanType.YEAR;
  const intervalCountStr = billIntervalCount === 1 ? '' : String(billIntervalCount);
  const planKeyStr = `${typeStr}${viewModeStr}${intervalCountStr}`;
  localStorage.setItem('SelectPlanKey', planKeyStr);
}
export function getPlanKey() {
  const planKey = localStorage.getItem('SelectPlanKey') as SubscriptionKeyType | undefined;
  return planKey;
}
export function removePlanKey() {
  localStorage.removeItem('SelectPlanKey');
}

interface PricingModalOriginOptions {
  /** campaign popup 的 CMS 名称 */
  popoupType?: string | null;
}

/** 打开定价弹窗 */
export function setPricingModalOrigin(origin: PricingModalOrigin, options: PricingModalOriginOptions = {}) {
  localStorage.setItem(PRICING_MODAL_ORIGIN_KEY, origin);
  localStorage.setItem(PRICING_MODAL_CLICK_ID_KEY, nanoid());

  if (origin !== PricingModalOrigin.CampaignPopup) {
    localStorage.removeItem(PRICING_MODAL_POPOUP_TYPE_KEY);
    return;
  }

  if (!options.popoupType) {
    localStorage.removeItem(PRICING_MODAL_POPOUP_TYPE_KEY);
    return;
  }

  localStorage.setItem(PRICING_MODAL_POPOUP_TYPE_KEY, options.popoupType);
}
/** 关闭定价弹窗 */
export function removePricingModalOrigin() {
  localStorage.removeItem(PRICING_MODAL_ORIGIN_KEY);
  localStorage.removeItem(PRICING_MODAL_CLICK_ID_KEY);
  localStorage.removeItem(PRICING_MODAL_POPOUP_TYPE_KEY);
}
export function getPricingModalOrigin() {
  return localStorage.getItem(PRICING_MODAL_ORIGIN_KEY) || null;
}
export function getPricingModalPopoupType() {
  return localStorage.getItem(PRICING_MODAL_POPOUP_TYPE_KEY) || null;
}
export function getPricingModalClickId() {
  return localStorage.getItem(PRICING_MODAL_CLICK_ID_KEY);
}

/** 定价页选择的产品 */
export function setSelectProduct(product: IProduct) {
  sessionStorage.setItem(SELECT_PRODUCT, JSON.stringify(product));
}
export function getSelectProduct() {
  return sessionStorage.getItem(SELECT_PRODUCT) || undefined;
}
export function removeSelectProduct() {
  sessionStorage.removeItem(SELECT_PRODUCT);
}
